// extracted by mini-css-extract-plugin
export default {"container":"ScreenTitle_container__lpEcu","title":"ScreenTitle_title__OAtMz"};